import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectorRef, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex, MessageType, UpdateStatusType } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import * as _ from 'underscore';
import { XMLService, SearchWrapper, SearchConfig } from '../../../services/xml/xml.service';
import { GenericPickerModalComponent } from '../../modals/generic-picker-modal/generic-picker-modal.component';
import { isArray, isString, isNullOrUndefined, isUndefined } from '../../../models/utils';
import { Subscription } from 'rxjs/internal/Subscription';
import * as lo_ from 'lodash';
import { ObjectActionListType, Permissions } from '../../../models/permission';
import { Corpus } from '../../../models/corpus';
import { ViewType } from '../../../models/view';
import { GenericInputComponent } from '../../generic-input/generic-input.component';
import { MetadataFiltersComponent } from '../../metadata-filters/metadata-filters.component';
import { MetadataService } from '../../../services/metadata/metadata.service';
import { Metadata } from '../../../models/metadata';
import { DOMAINS_MAX_DISPLAY_GRID_ENTRIES, METADATA_MAX_DISPLAY_GRID_ENTRIES } from '../../../models/constants';

@Component({
    standalone: false,
    selector: 'res-advanced-search-modal',
    templateUrl: './advanced-search-modal.component.html',
    styleUrls: ['./advanced-search-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class AdvancedSearchModalComponent extends BaseModalComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('freeformInput') freeformInput: GenericInputComponent;
    @ViewChild('metadataFilterAny') metadataFilterAny: MetadataFiltersComponent;
    @ViewChild('metadataFilterAll') metadataFilterAll: MetadataFiltersComponent;
    @ViewChild('metadataFilterNone') metadataFilterNone: MetadataFiltersComponent;
    isBusy = false;
    isBusyMessage: string;
    isSettingsBusy = false;

    modalClass = 'advanced-search-modal';
    modalAutomationId = 'advanced-search';
    modalHelpIndex = HelpIndex.myedisc_advanced_search;
    searchObject: any;
    defaultDatePlaceholders = ['Start YYYY-MM-DD ...', 'End YYYY-MM-DD ...'];
    filterClause = [{ name: 'AND' }, { name: 'OR' }];
    filterByClause = this.filterClause[0].name;
    domainRecipientsFilterClause = this.filterClause[0].name;
    xmlQuery: string;
    freeForm: any;
    isTCFDisabled: boolean;
    isInFreeFormMode: boolean;
    searchAliasList: any;
    dateError: boolean;
    private entityChangedEvent: Subscription;
    private retrieveMetadataValuesEvent: Subscription;
    generatedQueryInfo: any;
    disableDiscardButton = true;
    queryString = '';
    isAdvanceSearchFromWorkFlow = false;
    metadataFilterAnyList: any = [];
    metadataFilterAllList: any = [];
    metadataFilterNoneList: any = [];
    objectNameValue: any = [];
    metadataProperties = [];
    helpMetadataIndex = HelpIndex.metadata_list_dlg;
    metadataValueObjects = new Array<Metadata>;
    metadataFieldsWithValuePickers = [];
    sendersCombinedMetadata = 'fromsender';
    recipientsCombinedMetadata = 'toccbcc';
    sendersMetadataList = ['from', 'sender'];
    recipientsMetadataList = ['to', 'cc', 'bcc'];
    allDomainsMetadataList = ['senderdomains', 'rcvddomains'];

    // permissions
    hasTagsPermission: boolean;
    hasFoldersPermissions: boolean;
    hasCustodiansPermissions: boolean;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private commonService: CommonService,
        private router: Router,
        private xmlService: XMLService,
        public changeDetector: ChangeDetectorRef,
        private metadataService: MetadataService
    ) {
        super(modalService, modalRef);

        this.entityChangedEvent = this.commonService.getMessage(MessageType.entityChanged).subscribe((data) => {
            if (data === UpdateStatusType.ALIAS_LISTS) {
                this.loadInitData();
            }
        });

        this.retrieveMetadataValuesEvent = this.commonService.getMessage(MessageType.getMetadataValuesAfterPollComplete).subscribe(() => {
            if (this.metadataFieldsWithValuePickers) {
                this.getMetadataValuesForFields(this.metadataFieldsWithValuePickers);
            }
        })
    }

    ngOnInit(): void {
        this.queryString = this.modalData.advancedQuery.query;
        if (this.queryString) {
            setTimeout(() => { this.freeformInput?.colorize(); });
        }
        this.isAdvanceSearchFromWorkFlow = this.modalData.isAdvanceSearchFromWorkFlow;
        this.freeForm = { query: '' };
        this.initializeSearchObject();
        this.setTCFEnablement();
        this.loadInitData(true);
        this.hasTagsPermission = Permissions.checkUserPermission(ObjectActionListType.PRJ_TAGS);
        this.hasFoldersPermissions = Permissions.checkUserPermission(ObjectActionListType.ECA_FOLDER);
        this.hasCustodiansPermissions = Permissions.checkUserPermission(ObjectActionListType.ECA_CUSTODIAN);
        this.getAllMetadata();
    }

    openHelp = () => this.commonService.openHelp(this.helpMetadataIndex);

    getAllMetadata(): void {
        let properties = [];
        this.metadataService.tokenizationTypes().then(responseProperties => {
            if (responseProperties) {
                responseProperties.forEach(element => {
                    properties.push({ name: element.name, category: element.category, description: element.description });
                });
            }
            properties = properties.sort();
            this.metadataProperties = lo_.cloneDeep(properties);
            const emptyName = { query: '', selectedType: 'input', selectedValue: '', metadataProperties: [], allItems: [] };
            this.objectNameValue.metadataFilterAnyList = [lo_.cloneDeep(emptyName)];
            this.objectNameValue.metadataFilterAllList = [lo_.cloneDeep(emptyName)];
            this.objectNameValue.metadataFilterNoneList = [lo_.cloneDeep(emptyName)];

            this.objectNameValue.metadataFilterAnyList.forEach(rows => {
                rows.metadataProperties = lo_.cloneDeep(properties);
                rows.allItems = lo_.cloneDeep(properties);
            });
            this.objectNameValue.metadataFilterAllList.forEach(rows => {
                rows.metadataProperties = lo_.cloneDeep(properties);
                rows.allItems = lo_.cloneDeep(properties);
            });
            this.objectNameValue.metadataFilterNoneList.forEach(rows => {
                rows.metadataProperties = lo_.cloneDeep(properties);
                rows.allItems = lo_.cloneDeep(properties);
            });
        });
    }

    removeAllFromAnyList(): void {
        this.metadataFilterAny.deleteAllRows();
    }

    removeAllFromAllList(): void {
        this.metadataFilterAll.deleteAllRows();
    }

    removeAllFromNoneList(): void {
        this.metadataFilterNone.deleteAllRows();
    }

    ngAfterViewInit(): void {
        if (this.isInFreeFormMode && this.freeformInput) {
            this.freeformInput.setText(this.freeForm.query);
        } else {
            this.queryFocusChanged(null);
        }
        if (this.metadataFilterAny?.metadataWithValueSelector?.length > 0) {
            this.metadataFieldsWithValuePickers.push(...this.metadataFilterAny.metadataWithValueSelector);
        }
        this.metadataFieldsWithValuePickers.push(...this.sendersMetadataList);
        this.metadataFieldsWithValuePickers.push(...this.recipientsMetadataList);
        this.metadataFieldsWithValuePickers.push(...this.allDomainsMetadataList);
        this.getMetadataValuesForFields(this.metadataFieldsWithValuePickers);
    }

    keyPressEvent(event) {
        this.isInFreeFormMode = true;
        this.disableDiscardButton = false;
    }

    inputChanged(event?: any): void {
        setTimeout(() => {
            if (event?.source === 'user') {
                const deleteClipBoardEventTriggered = event.delta?.ops[0]?.delete || event.delta?.ops[1]?.delete;
                if (/\s/.test(event.delta?.ops[1]?.insert) || /\s/.test(event.delta?.ops[0]?.insert) || deleteClipBoardEventTriggered) {
                    this.isInFreeFormMode = true;
                    this.disableDiscardButton = false;
                    const range = this.freeformInput?.getSelection();
                    if (deleteClipBoardEventTriggered && this.freeformInput.getText().trim().length === 0) {
                        this.queryString = event.text.trim();
                        this.freeForm.query = this.freeformInput.capitalizeKeywords(event.text.trim());
                    } else {
                        this.freeformInput?.setText(this.freeformInput.capitalizeKeywords(this.freeformInput?.getText()));
                    }
                    this.freeformInput?.setSelection(range);
                }
                this.freeformInput.colorize();
            }
            this.queryString = this.freeformInput.getText();
            this.freeForm.query = this.freeformInput.getText();
            this.generatedQueryInfo = lo_.cloneDeep(this.freeForm);
        });
    }

    setCursorAtIndex() {
        setTimeout(() => {
            if (this.freeformInput) {
                const rangeIndex = this.freeformInput.getText().length;
                const range = { index: rangeIndex, length: 0 };
                this.freeformInput.setSelection(range);
            }
        });
    }

    setTCFEnablement() { // TCF = Tags Custodians Folders
        const isImport = (this.modalData && this.modalData.selectedNode &&
            ((this.modalData.selectedNode.target && this.modalData.selectedNode.target.data && this.modalData.selectedNode.target.data instanceof Corpus) ||
                this.modalData.selectedNode.name === 'Imports'));
        const isDataSet = (this.modalData && this.modalData.selectedNode && this.modalData.selectedNode instanceof Corpus);
        const hasHandle = this.modalData && this.modalData.selectedNode && this.modalData.selectedNode.handle;
        const optionalCall = hasHandle && !isImport && !isDataSet ? (() => Promise.resolve(
            this.restService.post(Endpoint.viewManager_getView, { handle: this.modalData.selectedNode.handle }).then(optionalPromise => {
                if (optionalPromise && optionalPromise.view) {
                    const view = optionalPromise.view;
                    this.isTCFDisabled = (view.viewType === ViewType.CORPUS_RESULT || view.viewType === ViewType.CORPUS_SET_RESULT ||
                        view.viewType === ViewType.CORPUS);
                }
            }))) : () => {
                this.isTCFDisabled = true;
            };

        optionalCall();
    }

    clearQueryClicked(): void {
        this.initializeSearchObject();
        this.queryFocusChanged();
        if (this.isInFreeFormMode) {
            this.freeForm.query = '';
            this.freeformInput.setText('');
            this.isInFreeFormMode = false;
            this.disableDiscardButton = true;
            this.setCursorAtIndex();
        }
        this.removeAllFromAnyList();
        this.removeAllFromAllList();
        this.removeAllFromNoneList();
    }

    initializeSearchObject(): void {
        this.searchObject = {
            oneOrMoreWords: { value: '' },
            allWords: { value: '' },
            noneWords: { value: '' },
            exactPhrase: { value: '' },
            withinProximity: 10,
            anyWords: { value: '' },
            anyDistanceWords: { value: '' },
            senders: { value: '' },
            recipients: { value: '' },
            subject: { value: '' },
            oneOrMoreTags: { value: '', list: [], selectedItems: [] },
            allTags: { value: '', list: [], selectedItems: [] },
            noneTags: { value: '', list: [], selectedItems: [] },
            anyCustodians: { value: '', list: [], selectedItems: [] },
            noneCustodians: { value: '', list: [], selectedItems: [] },
            anyFolders: { value: '', list: [], selectedItems: [] },
            noneFolders: { value: '', list: [], selectedItems: [] },
            senderDomains: { value: '', list: [], selectedItems: [], selectedDomainsPerList: {}, totalDomainsPerList: {}, selectedWholeDomainLists: {}, fullySelectedDomainLists: {} },
            senderDomainsNone: { value: '', list: [], selectedItems: [], selectedDomainsPerList: {}, totalDomainsPerList: {}, selectedWholeDomainLists: {}, fullySelectedDomainLists: {} },
            recipientDomains: { value: '', list: [], selectedItems: [], selectedDomainsPerList: {}, totalDomainsPerList: {}, selectedWholeDomainLists: {}, fullySelectedDomainLists: {} },
            recipientDomainsNone: { value: '', list: [], selectedItems: [], selectedDomainsPerList: {}, totalDomainsPerList: {}, selectedWholeDomainLists: {}, fullySelectedDomainLists: {} },
            anySenderAliases: { value: '', list: [], selectedItems: [] },
            noneSenderAliases: { value: '', list: [], selectedItems: [] },
            anyRecipientAliases: { value: '', list: [], selectedItems: [] },
            noneRecipientAliases: { value: '', list: [], selectedItems: [] },
            anyDocumentAliases: { value: '', list: [], selectedItems: [] },
            noneDocumentAliases: { value: '', list: [], selectedItems: [] },
            dateFilters: {
                expandDateRange: false,
                includeParentEmails: false,
                useEmailCreatedDate: false,
                searchTermsType: true,
                dateRangeType: 'allDates',
                flags: {
                    sent: true, received: true,
                    datestarted: true, dateended: false,
                    dateaccessed: false, datecreated: true, datemodified: true,
                    lastaccesstime: false, createdtime: true, lastmodifiedtime: true
                },
                dateRangeTypeSet: () => {
                    this.searchObject.dateFilters.flags.sent = this.searchObject.dateFilters.dateRangeType !== 'customDates';
                    this.searchObject.dateFilters.flags.received = this.searchObject.dateFilters.dateRangeType !== 'customDates';

                    this.searchObject.dateFilters.flags.datestarted = this.searchObject.dateFilters.dateRangeType !== 'customDates';
                    this.searchObject.dateFilters.flags.dateended = false;

                    this.searchObject.dateFilters.flags.dateaccessed = false;
                    this.searchObject.dateFilters.flags.datecreated = this.searchObject.dateFilters.dateRangeType !== 'customDates';
                    this.searchObject.dateFilters.flags.datemodified = this.searchObject.dateFilters.dateRangeType !== 'customDates';

                    this.searchObject.dateFilters.flags.lastaccesstime = false;
                    this.searchObject.dateFilters.flags.createdtime = this.searchObject.dateFilters.dateRangeType !== 'customDates';
                    this.searchObject.dateFilters.flags.lastmodifiedtime = this.searchObject.dateFilters.dateRangeType !== 'customDates';
                    this.queryFocusChanged(null);
                }
            },
            startDate: null, endDate: null,
            metadataAnyFilters: null,
            metadataAllFilters: null,
            metadataNoneFilters: null,
        };
    }

    loadInitData(populateAfter = false): void {
        // load search alias list
        this.isBusy = true;
        this.isBusyMessage = 'Loading ... ';
        this.restService.post(Endpoint.projectManager_listAliasList, { handle: this.commonService.currentProject.handle, count: 0, startIndex: 0 }).then(response => {
            if (response && response.aliasList) {
                this.searchAliasList = response.aliasList;
                this.isBusy = false;
                if (populateAfter) {
                    if (this.modalData?.advancedQuery?.xmlQuery && isString(this.modalData.advancedQuery.xmlQuery)) {
                        this.getSearchObjectFromXmlQuery(this.modalData.advancedQuery.xmlQuery);
                    }
                }
            }
        }, error => {
            console.log('Initial loading of data failed' + error);
        });
    }

    okEnabled(): boolean {
        const inputText = this.freeformInput?.getText();
        return !this.isBusy && inputText?.trim() !== '';
    }

    ok(): void {
        const isEmptySearchObject = isNullOrUndefined(this.generatedQueryInfo);
        const inputQuery = this.freeformInput.capitalizeKeywords(this.freeformInput.getText().trim());
        if (this.isInFreeFormMode) {
            const freeFormSearchWrapper = new SearchWrapper(new SearchConfig({ isSimpleSearch: false, isFromFreeFormQuery: true }));
            // unescape characters (&nbsp; , &lt; , &gt;)
            this.freeForm.query = inputQuery.replace(/\u00a0/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').trim();
            freeFormSearchWrapper.keywords.value = isEmptySearchObject ? this.removeParensFromStartEnd(inputQuery) : inputQuery;
            this.freeForm.xmlQuery = this.xmlService.objectToXMLQuery(freeFormSearchWrapper);
        }
        this.freeformInput.highlightNOW(inputQuery);
        this.closeModal(true, { query: inputQuery, queryObject: isEmptySearchObject ? null : this.searchObject, xmlQuery: this.freeForm.xmlQuery, initialGeneratedQuery: this.generatedQueryInfo ? this.generatedQueryInfo.query : null });
    }

    // if date picker input was clicked set input placeholder to YYYY-MM-DD
    // if x button or x button icon was clicked reset input placeholder to default
    onDateClick(datePicker: any, mode: any): void {
        if (datePicker && datePicker.target) {
            const crtControl = datePicker.target;
            const defaultPlaceholder = mode === 'start' ? this.defaultDatePlaceholders[0] : this.defaultDatePlaceholders[1];
            if (crtControl.placeholder) {
                if (this.defaultDatePlaceholders.indexOf(crtControl.placeholder) !== -1) {
                    crtControl.placeholder = 'YYYY-MM-DD';
                } else {
                    crtControl.placeholder = defaultPlaceholder;
                }
            } else if (crtControl.id === 'pickerClearBtn') {   // x button was clicked
                crtControl.parentElement.children['datepickerinput'].placeholder = defaultPlaceholder;
            } else if (crtControl.parentElement && crtControl.parentElement.id === 'pickerClearBtn') {  // x button icon was clicked
                crtControl.parentElement.parentElement.children['datepickerinput'].placeholder = defaultPlaceholder;
            }
        }
    }

    // on date picker input lost focus and date was not changed reset placeholder to default
    onFocusLost(datePicker: any, mode: any): void {
        if (datePicker && datePicker.target) {
            const crtControl = datePicker.target;
            const defaultPlaceholder = mode === 'start' ? this.defaultDatePlaceholders[0] : this.defaultDatePlaceholders[1];
            if (crtControl.placeholder) {
                if (this.defaultDatePlaceholders.indexOf(crtControl.placeholder) === -1) {
                    crtControl.placeholder = defaultPlaceholder;
                }
            }
        }
    }

    discardFreeformChanges(): void {
        this.isInFreeFormMode = false;
        this.freeForm = lo_.cloneDeep(this.generatedQueryInfo);
        if (this.freeForm.xmlQuery.includes('IsFromFreeFormText')) {
            this.freeformInput.highlightNOW(this.generatedQueryInfo.initialGeneratedQuery);
            this.queryFocusChanged();
        } else {
            const isQueryStringEmpty = this.freeForm.initialQuery.length === 0 ? true : false;
            this.freeformInput?.highlightNOW(this.freeForm.initialQuery, isQueryStringEmpty, true);
        }
        this.generatedQueryInfo = null;
        this.disableDiscardButton = true;
        this.setCursorAtIndex();
    }

    openTargetPicker(pickerType: any, filterType: any, item: any): void {

        item.selectedItems = this.getWordsList(item.value, pickerType);

        if (item.selectedItems.length === 0) {
            item.selectedDomainsPerList = {};
            item.totalDomainsPerList = {};
            item.selectedWholeDomainLists = {};
            item.fullySelectedDomainLists = {};
        }

        const data: any = {
            entityType: pickerType,
            filterType: filterType,
            items: item.selectedItems,
            metadataObject: null,
        };
        let pickerModalVerticalPercent = 'vertical-percent-50';

        if (pickerType === 'senders' || pickerType === 'recipients') {
            pickerModalVerticalPercent = 'vertical-percent-80';
            data.metadataObject = pickerType === 'senders' ? this.getObjectForMetadata(this.sendersCombinedMetadata) : this.getObjectForMetadata(this.recipientsCombinedMetadata);
        }

        // For domains, pass the stored selection maps to restore previous selections
        if (pickerType === 'domains') {
            data.selectedDomainsPerList = item.selectedDomainsPerList || {};
            data.totalDomainsPerList = item.totalDomainsPerList || {};
            data.selectedWholeDomainLists = item.selectedWholeDomainLists || {};
            data.fullySelectedDomainLists = item.fullySelectedDomainLists || {};
        }

        this.commonService.openModal(GenericPickerModalComponent, { modalData: data, class: pickerType === 'domains' || pickerType === 'alias-list' ? 'horizontal-px-1200' : pickerModalVerticalPercent }).then(response => {
            if (response && response.modalResult && response.modalData) {
                this.parseSelectorData(response.modalData, this.searchObject[filterType], pickerType);
                this.queryFocusChanged(null);
            }
        });
    }

    openMetadataPicker(rowData, filterType: string) {
        if (rowData) {
            const metadataObject = this.getObjectForMetadata(rowData.selectedValue);
            if (metadataObject?.values?.length > METADATA_MAX_DISPLAY_GRID_ENTRIES) {
                metadataObject.values = metadataObject.values.splice(0, METADATA_MAX_DISPLAY_GRID_ENTRIES);
            }
            const data = {
                entityType: 'metadata',
                selectedMetadata: rowData.selectedValue,
                metadataObject: metadataObject,
                items: this.getWordsList(rowData.query, 'metadata')
            };
            this.commonService.openModal(GenericPickerModalComponent, { modalData: data, class: 'vertical-percent-70' }).then(response => {
                if (response?.modalResult && response?.modalData) {
                    const selectedMetadataValues = response?.modalData;
                    let itemsString = '';
                    selectedMetadataValues.forEach((item, idx) => {
                        itemsString += '\"' + item.name + '\"' + ((idx < selectedMetadataValues.length - 1) ? ' ' : '');
                    });
                    rowData.query = itemsString;
                    rowData.isPickerSelection = true;
                    this.parseMetadataFilters(filterType);
                }
            });
        }
    }

    getObjectForMetadata(metadataField: string): Metadata {
        let metadataFieldObj = null;
        if (metadataField && this.metadataValueObjects?.length > 0) {
            metadataFieldObj = this.metadataValueObjects.find(obj => obj.field === metadataField)
        }
        return metadataFieldObj;
    }

    parseSelectorData(selectedItems: any, listContainer: any, pickerType?: string): void {
        // Handle new structured response from domains picker
        if (pickerType === 'domains' && (selectedItems?.partiallySelectedDomains || selectedItems?.fullySelectedDomainLists || selectedItems?.selectedWholeDomainLists)) {
            // Three categories of selections:
            // 1. partiallySelectedDomains - individual domain names (partial selection)
            // 2. fullySelectedDomainLists - DL names when all domains are selected
            // 3. selectedWholeDomainLists - DL names for empty lists or whole list selections

            const partialDomains = selectedItems.partiallySelectedDomains || [];
            const fullySelectedLists = selectedItems.fullySelectedDomainLists || [];
            const wholeDomainLists = selectedItems.selectedWholeDomainLists || [];

            let itemsString = '';
            listContainer.selectedItems = [];
            listContainer.list = [];

            // Add individual domain names for partial selections
            partialDomains.forEach((item, idx) => {
                itemsString += item.name;
                listContainer.selectedItems.push(item.name);
                listContainer.list.push(item);
                // Add space if more items follow
                if (idx < partialDomains.length - 1 || fullySelectedLists.length > 0 || wholeDomainLists.length > 0) {
                    itemsString += ' ';
                }
            });

            // Add domain list names for fully selected lists (all domains selected)
            fullySelectedLists.forEach((list, idx) => {
                itemsString += '\"' + list.name + '\"';
                listContainer.selectedItems.push(list.name);
                listContainer.list.push(list);
                // Add space if more items follow
                if (idx < fullySelectedLists.length - 1 || wholeDomainLists.length > 0) {
                    itemsString += ' ';
                }
            });

            // Add domain list names for whole list selections (empty lists or selected without individual domains)
            wholeDomainLists.forEach((list, idx) => {
                itemsString += '\"' + list.name + '\"';
                listContainer.selectedItems.push(list.name);
                listContainer.list.push(list);
                if (idx < wholeDomainLists.length - 1) {
                    itemsString += ' ';
                }
            });

            listContainer.value = itemsString;

            // Store the selection maps for restoring when modal is reopened
            listContainer.selectedDomainsPerList = selectedItems.selectedDomainsPerList || {};
            listContainer.totalDomainsPerList = selectedItems.totalDomainsPerList || {};
            listContainer.selectedWholeDomainLists = selectedItems.selectedWholeDomainListsMap || {};
            listContainer.fullySelectedDomainLists = selectedItems.fullySelectedDomainListsMap || {};
        } else if (isArray(selectedItems)) {
            let itemsString = '';
            listContainer.selectedItems = [];
            listContainer.list = selectedItems;
            selectedItems.forEach((item, idx) => {

                itemsString += '\"' + item.name + '\"' + ((idx < selectedItems.length - 1) ? ' ' : '');
                listContainer.selectedItems.push(item.name);
            });
            listContainer.value = itemsString;
        }
    }

    parseMetadataFilters(type: string) {
        switch (type) {
            case 'all':
                this.searchObject.metadataAllFilters = this.getMetadataFilterInfo(this.metadataFilterAll.dataSource?.data);
                break;
            case 'any':
                this.searchObject.metadataAnyFilters = this.getMetadataFilterInfo(this.metadataFilterAny.dataSource?.data);
                break;
            case 'none':
                this.searchObject.metadataNoneFilters = this.getMetadataFilterInfo(this.metadataFilterNone.dataSource?.data);
                break;
        }
        this.queryFocusChanged();
    }

    getMetadataFilterInfo(list: Array<any>): Array<any> {
        let listOfMetadatas = null;
        if (list?.length > 0) {
            listOfMetadatas = [];
            let metadataRow = null;
            list.forEach(elem => {
                if (elem.selectedValue && !elem.hasError) {
                    switch (elem.selectedType) {
                        case 'input':
                            metadataRow = elem.query ? { query: elem.query, selectedValue: elem.selectedValue } : null;
                            break;
                        case 'date':
                            metadataRow = (elem.startDate || elem.endDate) ? { selectedValue: elem.selectedValue, startDate: elem.startDate, endDate: elem.endDate } : null;
                            break;
                        case 'range':
                            metadataRow = (elem.minResult || elem.minResult === 0 || elem.maxResult || elem.maxResult === 0) ? { selectedValue: elem.selectedValue, minResult: elem.minResult, maxResult: elem.maxResult } : null;
                            break;
                    }
                    if (metadataRow) {
                        metadataRow.selectedType = elem.selectedType;
                        metadataRow.isPickerSelection = elem.isPickerSelection;
                        listOfMetadatas.push(metadataRow);
                    }
                }
            });
            if (listOfMetadatas.length === 0) {
                listOfMetadatas = null;
            }
        }
        return listOfMetadatas;
    }

    queryFocusChanged(searchTerm?: any, xmlQuery?: any): void {
        if (!this.isInFreeFormMode) {
            if (searchTerm && searchTerm.list && (searchTerm && searchTerm.list.length === 0 || searchTerm.value === '')) {
                searchTerm.selectedItems = [];
                searchTerm.list = [];
            }

            this.xmlQuery = xmlQuery ? xmlQuery : this.getXmlQueryFromSearchObject();
            let query = this.xmlService.xmlToQueryConverter(this.xmlQuery);
            if (!query || query === '()') {
                query = '';
            }
            this.freeForm.query = query;
            this.freeForm.initialQuery = query;
            this.freeForm.xmlQuery = this.xmlQuery;
            this.checkFreeformScroll();
            this.setInput();
            this.freeformInput?.colorize();
        }
    }

    hasRealValue(field: any): boolean {
        return (field.value !== '' && field.value !== '\"' && field.value !== '\"\"');
    }

    getXmlQueryFromSearchObject(): string {
        const config = new SearchConfig({ isSimpleSearch: false });
        const advancedSearchWrapper = new SearchWrapper(config);

        if (this.hasRealValue(this.searchObject.oneOrMoreWords)) {
            advancedSearchWrapper.oneOrMoreWords.value = this.searchObject.oneOrMoreWords.value;
        }
        if (this.hasRealValue(this.searchObject.allWords)) {
            advancedSearchWrapper.allOfTheseWords.value = this.searchObject.allWords.value;
        }
        if (this.hasRealValue(this.searchObject.noneWords)) {
            advancedSearchWrapper.noneOfTheseWords.value = this.searchObject.noneWords.value;
        }

        if (this.searchObject.anyWords.value !== '' && this.searchObject.anyDistanceWords.value !== '') {
            advancedSearchWrapper.theseWordsWithin.these = this.searchObject.anyWords.value;
            advancedSearchWrapper.theseWordsWithin.those = this.searchObject.anyDistanceWords.value;

            if (!this.searchObject.withinProximity) {
                this.searchObject.withinProximity = 1;
            }
            advancedSearchWrapper.theseWordsWithin.distance = this.searchObject.withinProximity;
        }

        if (this.searchObject.exactPhrase.value !== '') {
            advancedSearchWrapper.exactPhrase.value = this.searchObject.exactPhrase.value;
        }

        if (!this.isTCFDisabled) {
            advancedSearchWrapper.tags.anyTags = this.searchObject.oneOrMoreTags.value;
            advancedSearchWrapper.tags.allTags = this.searchObject.allTags.value;
            advancedSearchWrapper.tags.noneTags = this.searchObject.noneTags.value;

            advancedSearchWrapper.custodians.anyItems = this.searchObject.anyCustodians.value;
            advancedSearchWrapper.custodians.noneItems = this.searchObject.noneCustodians.value;

            advancedSearchWrapper.folders.anyItems = this.searchObject.anyFolders.value;
            advancedSearchWrapper.folders.noneItems = this.searchObject.noneFolders.value;
        }

        advancedSearchWrapper.domains.senderDomains = this.buildValue(this.searchObject.senderDomains);
        advancedSearchWrapper.domains.senderDomainsNone = this.buildValue(this.searchObject.senderDomainsNone.value);
        advancedSearchWrapper.domains.recipientDomainsOperation = this.domainRecipientsFilterClause.toLowerCase();
        advancedSearchWrapper.domains.receiverDomains = this.buildValue(this.searchObject.recipientDomains);
        advancedSearchWrapper.domains.receiverDomainsNone = this.buildValue(this.searchObject.recipientDomainsNone.value);

        if (!advancedSearchWrapper.aliases.aliasListForSearch) {
            advancedSearchWrapper.aliases.aliasListForSearch = this.searchAliasList;
        }

        if (this.searchObject.anySenderAliases.value !== '') {
            advancedSearchWrapper.aliases.someSenderAliases = this.searchObject.anySenderAliases.value;
        }
        if (this.searchObject.noneSenderAliases.value !== '') {
            advancedSearchWrapper.aliases.noneSenderAliases = this.searchObject.noneSenderAliases.value;
        }
        if (this.searchObject.anyRecipientAliases.value !== '') {
            advancedSearchWrapper.aliases.someRecipientAliases = this.searchObject.anyRecipientAliases.value;
        }
        if (this.searchObject.noneRecipientAliases.value !== '') {
            advancedSearchWrapper.aliases.noneRecipientAliases = this.searchObject.noneRecipientAliases.value;
        }
        if (this.searchObject.anyDocumentAliases.value !== '') {
            advancedSearchWrapper.aliases.someOfAliasesInContent = this.searchObject.anyDocumentAliases.value;
        }
        if (this.searchObject.noneDocumentAliases.value !== '') {
            advancedSearchWrapper.aliases.noneOfAliasesInContent = this.searchObject.noneDocumentAliases.value;
        }

        if (this.searchObject.subject.value !== '') {
            advancedSearchWrapper.subject.value = this.searchObject.subject.value;
        }

        if (this.searchObject.senders !== '') {
            advancedSearchWrapper.senderRecipient.senders.peoples = this.searchObject.senders.value;
            advancedSearchWrapper.senderRecipient.operation = this.filterByClause.toLowerCase();
        }

        if (this.searchObject.recipients !== '') {
            advancedSearchWrapper.senderRecipient.recipients.peoples = this.searchObject.recipients.value;
            advancedSearchWrapper.senderRecipient.operation = this.filterByClause.toLowerCase();
        }

        if (this.searchObject.startDate || this.searchObject.endDate) {
            advancedSearchWrapper.dates.flags = {
                sent: this.searchObject.dateFilters.flags.sent,
                received: this.searchObject.dateFilters.flags.received,
                datestarted: this.searchObject.dateFilters.flags.datestarted,
                dateended: this.searchObject.dateFilters.flags.dateended,
                dateaccessed: this.searchObject.dateFilters.flags.dateaccessed,
                datecreated: this.searchObject.dateFilters.flags.datecreated,
                datemodified: this.searchObject.dateFilters.flags.datemodified,
                lastaccesstime: this.searchObject.dateFilters.flags.lastaccesstime,
                createdtime: this.searchObject.dateFilters.flags.createdtime,
                lastmodifiedtime: this.searchObject.dateFilters.flags.lastmodifiedtime
            };

            advancedSearchWrapper.dates.settings.dateRangeType = this.searchObject.dateFilters.dateRangeType;
            advancedSearchWrapper.dates.settings.includeParentEmails = this.searchObject.dateFilters.includeParentEmails;
            advancedSearchWrapper.dates.settings.useEmailCreatedDate = this.searchObject.dateFilters.useEmailCreatedDate;
            advancedSearchWrapper.dates.settings.searchTermsType = this.searchObject.dateFilters.searchTermsType ? 'family' : 'document';
            advancedSearchWrapper.dates.settings.expandDateRange = this.searchObject.dateFilters.expandDateRange;

            if (this.searchObject.startDate) {
                advancedSearchWrapper.dates.beginDate = lo_.cloneDeep(this.searchObject.startDate);
                if (this.searchObject.dateFilters.expandDateRange) {
                    advancedSearchWrapper.dates.beginDate.setDate(advancedSearchWrapper.dates.beginDate.getDate() - 1);
                }
            }
            if (this.searchObject.endDate) {
                advancedSearchWrapper.dates.endDate = lo_.cloneDeep(this.searchObject.endDate);
                if (this.searchObject.dateFilters.expandDateRange) {
                    advancedSearchWrapper.dates.endDate.setDate(advancedSearchWrapper.dates.endDate.getDate() + 1);
                }
            }

            this.compareDateRange();
        }

        if (this.searchObject.metadataAllFilters) {
            advancedSearchWrapper.metadatas.allFilterList = lo_.cloneDeep(this.searchObject.metadataAllFilters);
        }
        if (this.searchObject.metadataAnyFilters) {
            advancedSearchWrapper.metadatas.anyFilterList = lo_.cloneDeep(this.searchObject.metadataAnyFilters);
        }
        if (this.searchObject.metadataNoneFilters) {
            advancedSearchWrapper.metadatas.noneFilterList = lo_.cloneDeep(this.searchObject.metadataNoneFilters);
        }

        // last operation
        const xmlQuery = this.xmlService.objectToXMLQuery(advancedSearchWrapper);  //  advancedSearchWrapper.objectToXml();
        return xmlQuery;
    }

    private buildValue(senderDomains: any): string {
        // Handle both cases:
        // 1. Object with .value property (e.g., this.searchObject.senderDomains)
        // 2. String value directly (e.g., this.searchObject.senderDomainsNone.value)
        if (typeof senderDomains === 'string') {
            return senderDomains || '';
        }

        if (senderDomains?.value) {
            return senderDomains.value;
        }

        return '';
    }

    removeParensFromStartEnd(termQuery: string): string {
        if (termQuery?.startsWith('(') && termQuery.endsWith(')')) {
            return termQuery.slice(1, -1);
        }
        return termQuery;
    }

    restoreMetadataFiltersFromSearchObject(list, listName): void {
        if (list) {
            if (!list.find(m => m.query === '' && m.selectedValue === '')) {
                list.push({ query: '', selectedType: 'input', selectedValue: '', metadataProperties: [], allItems: [] });
            }
            list.forEach(w => {
                w.metadataProperties = lo_.cloneDeep(this.metadataProperties);
                w.allItems = lo_.cloneDeep(this.metadataProperties);
            });
            this.objectNameValue[listName] = list;
        }
    }

    getSearchObjectFromXmlQuery(xmlQuery: string): void {
        const queryObject = this.xmlService.xmlToQueryConverter(xmlQuery, true);
        if (queryObject && queryObject['IsFromFreeFormText']) {
            let freeFormQuery = queryObject['query'];
            if (this.modalData?.advancedQuery?.queryObject) {
                // search was not runned yet, after changed it in free form the user re-opened the modal with Edit button
                this.searchObject = this.modalData.advancedQuery.queryObject;
                this.disableDiscardButton = false;
                this.generatedQueryInfo = lo_.cloneDeep(this.modalData.advancedQuery);
                if (this.modalData.advancedQuery.initialGeneratedQuery) {
                    this.generatedQueryInfo.query = this.modalData.advancedQuery.initialGeneratedQuery;
                }
                freeFormQuery = this.removeParensFromStartEnd(freeFormQuery);
                this.restoreMetadataFiltersFromSearchObject(this.searchObject.metadataAllFilters, 'metadataFilterAllList');
                this.restoreMetadataFiltersFromSearchObject(this.searchObject.metadataAnyFilters, 'metadataFilterAnyList');
                this.restoreMetadataFiltersFromSearchObject(this.searchObject.metadataNoneFilters, 'metadataFilterNoneList');
            }
            this.freeForm.query = freeFormQuery;
            this.freeForm.initialQuery = freeFormQuery;
            this.freeForm.xmlQuery = xmlQuery;
            this.xmlQuery = xmlQuery;
            this.isInFreeFormMode = true;
            this.freeformInput?.setText(freeFormQuery);
        } else {
            const config = new SearchConfig({ isSimpleSearch: false });
            const advancedSearchWrapper = new SearchWrapper(config);
            advancedSearchWrapper.xmlQueryToObject(xmlQuery);

            if (advancedSearchWrapper.oneOrMoreWords.value) {
                this.searchObject.oneOrMoreWords.value = advancedSearchWrapper.oneOrMoreWords.value;
            }
            if (advancedSearchWrapper.allOfTheseWords.value) {
                this.searchObject.allWords.value = advancedSearchWrapper.allOfTheseWords.value;
            }
            if (advancedSearchWrapper.noneOfTheseWords.value) {
                this.searchObject.noneWords.value = advancedSearchWrapper.noneOfTheseWords.value;
            }

            if (advancedSearchWrapper.theseWordsWithin.these && advancedSearchWrapper.theseWordsWithin.those) {
                this.searchObject.anyWords.value = advancedSearchWrapper.theseWordsWithin.these;
                this.searchObject.anyDistanceWords.value = advancedSearchWrapper.theseWordsWithin.those;
                this.searchObject.withinProximity = advancedSearchWrapper.theseWordsWithin.distance;
            }

            if (advancedSearchWrapper.exactPhrase.value) {
                this.searchObject.exactPhrase.value = (advancedSearchWrapper.exactPhrase.value as string).replace(/^"(.+(?="$))"$/, '$1');
            }

            if (!this.isTCFDisabled) {
                if (advancedSearchWrapper.tags.anyTags) {
                    this.searchObject.oneOrMoreTags.value = advancedSearchWrapper.tags.anyTags;
                }
                if (advancedSearchWrapper.tags.allTags) {
                    this.searchObject.allTags.value = advancedSearchWrapper.tags.allTags;
                }
                if (advancedSearchWrapper.tags.noneTags) {
                    this.searchObject.noneTags.value = advancedSearchWrapper.tags.noneTags;
                }

                if (advancedSearchWrapper.custodians.anyItems) {
                    this.searchObject.anyCustodians.value = advancedSearchWrapper.custodians.anyItems;
                }
                if (advancedSearchWrapper.custodians.noneItems) {
                    this.searchObject.noneCustodians.value = advancedSearchWrapper.custodians.noneItems;
                }

                if (advancedSearchWrapper.folders.anyItems) {
                    this.searchObject.anyFolders.value = advancedSearchWrapper.folders.anyItems;
                }
                if (advancedSearchWrapper.folders.noneItems) {
                    this.searchObject.noneFolders.value = advancedSearchWrapper.folders.noneItems;
                }
            }

            if (advancedSearchWrapper.domains.senderDomains) {
                this.searchObject.senderDomains.value = advancedSearchWrapper.domains.senderDomains;
            }
            if (advancedSearchWrapper.domains.senderDomainsNone) {
                this.searchObject.senderDomainsNone.value = advancedSearchWrapper.domains.senderDomainsNone;
            }
            if (advancedSearchWrapper.domains.receiverDomains) {
                this.searchObject.recipientDomains.value = advancedSearchWrapper.domains.receiverDomains;
            }
            if (advancedSearchWrapper.domains.receiverDomainsNone) {
                this.searchObject.recipientDomainsNone.value = advancedSearchWrapper.domains.receiverDomainsNone;
            }
            // Restore the recipientDomainsOperation (AND/OR clause)
            if (advancedSearchWrapper.domains.recipientDomainsOperation) {
                this.domainRecipientsFilterClause = advancedSearchWrapper.domains.recipientDomainsOperation.toUpperCase();
            }

            if (advancedSearchWrapper.aliases.someSenderAliases) {
                this.searchObject.anySenderAliases.value = advancedSearchWrapper.aliases.someSenderAliases;
            }
            if (advancedSearchWrapper.aliases.noneSenderAliases) {
                this.searchObject.noneSenderAliases.value = advancedSearchWrapper.aliases.noneSenderAliases;
            }
            if (advancedSearchWrapper.aliases.someRecipientAliases) {
                this.searchObject.anyRecipientAliases.value = advancedSearchWrapper.aliases.someRecipientAliases;
            }
            if (advancedSearchWrapper.aliases.noneRecipientAliases) {
                this.searchObject.noneRecipientAliases.value = advancedSearchWrapper.aliases.noneRecipientAliases;
            }
            if (advancedSearchWrapper.aliases.someOfAliasesInContent) {
                this.searchObject.anyDocumentAliases.value = advancedSearchWrapper.aliases.someOfAliasesInContent;
            }
            if (advancedSearchWrapper.aliases.noneOfAliasesInContent) {
                this.searchObject.noneDocumentAliases.value = advancedSearchWrapper.aliases.noneOfAliasesInContent;
            }

            if (advancedSearchWrapper.subject.value) {
                this.searchObject.subject.value = advancedSearchWrapper.subject.value.replace(/^"(.+(?="$))"$/, '$1');
            }

            if (advancedSearchWrapper.senderRecipient.senders.peoples) {
                this.searchObject.senders.value = advancedSearchWrapper.senderRecipient.senders.peoples;
                this.filterByClause = advancedSearchWrapper.senderRecipient.operation.toUpperCase();
            }
            if (advancedSearchWrapper.senderRecipient.recipients.peoples) {
                this.searchObject.recipients.value = advancedSearchWrapper.senderRecipient.recipients.peoples;
                this.filterByClause = advancedSearchWrapper.senderRecipient.operation.toUpperCase();
            }

            if (advancedSearchWrapper.dates.beginDate || advancedSearchWrapper.dates.endDate) {
                this.searchObject.dateFilters.flags.sent = advancedSearchWrapper.dates.flags.sent;
                this.searchObject.dateFilters.flags.received = advancedSearchWrapper.dates.flags.received;
                this.searchObject.dateFilters.flags.datestarted = advancedSearchWrapper.dates.flags.datestarted;
                this.searchObject.dateFilters.flags.dateended = advancedSearchWrapper.dates.flags.dateended;
                this.searchObject.dateFilters.flags.dateaccessed = advancedSearchWrapper.dates.flags.dateaccessed;
                this.searchObject.dateFilters.flags.datecreated = advancedSearchWrapper.dates.flags.datecreated;
                this.searchObject.dateFilters.flags.datemodified = advancedSearchWrapper.dates.flags.datemodified;
                this.searchObject.dateFilters.flags.lastaccesstime = advancedSearchWrapper.dates.flags.lastaccesstime;
                this.searchObject.dateFilters.flags.createdtime = advancedSearchWrapper.dates.flags.createdtime;
                this.searchObject.dateFilters.flags.lastmodifiedtime = advancedSearchWrapper.dates.flags.lastmodifiedtime;

                this.searchObject.dateFilters.dateRangeType = advancedSearchWrapper.dates.settings.dateRangeType;
                this.searchObject.dateFilters.includeParentEmails = advancedSearchWrapper.dates.settings.includeParentEmails;
                this.searchObject.dateFilters.useEmailCreatedDate = advancedSearchWrapper.dates.settings.useEmailCreatedDate;
                this.searchObject.dateFilters.searchTermsType = advancedSearchWrapper.dates.settings.searchTermsType === 'family';
                this.searchObject.dateFilters.expandDateRange = advancedSearchWrapper.dates.settings.expandDateRange;

                if (advancedSearchWrapper.dates.beginDate) {
                    this.searchObject.startDate = advancedSearchWrapper.dates.beginDate;
                    if (this.searchObject.dateFilters.expandDateRange) {
                        this.searchObject.startDate.setDate(advancedSearchWrapper.dates.beginDate.getDate() + 1);
                    }
                }
                if (advancedSearchWrapper.dates.endDate) {
                    this.searchObject.endDate = advancedSearchWrapper.dates.endDate;
                    if (this.searchObject.dateFilters.expandDateRange) {
                        this.searchObject.endDate.setDate(advancedSearchWrapper.dates.endDate.getDate() - 1);
                    }
                }
            }

            if (advancedSearchWrapper.metadatas.allFilterList) {
                this.setMetadataFiltersToComponent('metadataAllFilters', advancedSearchWrapper.metadatas.allFilterList, 'metadataFilterAllList');
            }
            if (advancedSearchWrapper.metadatas.anyFilterList) {
                this.setMetadataFiltersToComponent('metadataAnyFilters', advancedSearchWrapper.metadatas.anyFilterList, 'metadataFilterAnyList');
            }
            if (advancedSearchWrapper.metadatas.noneFilterList) {
                this.setMetadataFiltersToComponent('metadataNoneFilters', advancedSearchWrapper.metadatas.noneFilterList, 'metadataFilterNoneList');
            }

            this.queryFocusChanged(null, xmlQuery);
        }
    }

    setMetadataFiltersToComponent(metadataList: string, searchWrapperList: Array<any>, objectName: string): void {
        if (searchWrapperList) {
            this.searchObject[metadataList] = lo_.cloneDeep(searchWrapperList);
            const filterEmptyRows = searchWrapperList.filter(row => isUndefined(row.query) || row.query !== '');
            this.restoreMetadataFiltersFromSearchObject(filterEmptyRows, objectName);
        }
    }

    compareDateRange(): void {
        if ((this.searchObject.startDate && this.searchObject.endDate) && this.searchObject.endDate.getTime() < this.searchObject.startDate.getTime()) {
            this.dateError = true;
        } else {
            this.dateError = false;
        }
        this.changeDetector.detectChanges();
    }

    getWordsList(words: string, pickerType: any): Array<string> {
        let list = [];
        const regEx = /".*?"/g;
        let match;
        do {
            match = regEx.exec(words);
            if (match && match.length > 0) {
                const item = match[0].replace(/\"/g, '');
                if (item) {
                    list.push(item);
                }
            }
        } while (match);
        if (list.length === 0) {
            if (words?.length > 0 && (pickerType === 'alias-list' || pickerType === 'domains')) {
                list = words.split(' ');
            } else {
                const itemMatched = words.replace(/\"/g, '');
                if (itemMatched) {
                    list.push(itemMatched);
                }
            }
        }
        return list;
    }


    checkFreeformScroll(): boolean {
        if (document.getElementById('queryPanel') && document.getElementById('queryOutputPanel')) {
            return document.getElementById('queryOutputPanel').clientHeight < document.getElementById('queryOutputPanel').scrollHeight;
        }
    }

    setInput(): void {
        if (((window as any).hljs == null && !this.commonService.currentBrowserIsIE) || !this.freeformInput) return;
        this.freeformInput?.setText(this.freeForm.query);
    }

    getMetadataValuesForFields(listOfFields: Array<string>): void {
        if (this.commonService.projectData?.handle && listOfFields?.length > 0) {
            const requestData = { viewHandle: this.commonService.projectData.handle, metadataFields: listOfFields, combinedFields: { fromsender: this.sendersMetadataList, toccbcc: this.recipientsMetadataList }, maxEntries: DOMAINS_MAX_DISPLAY_GRID_ENTRIES };
            this.restService.post(Endpoint.projectManager_getMetadataValues, requestData).then((response) => {
                if (response?.metadataValues) {
                    response.metadataValues.forEach(val => this.metadataValueObjects.push(new Metadata(val)));
                }
            });
        }
    }

    ngOnDestroy(): void {
        this.entityChangedEvent.unsubscribe();
        this.retrieveMetadataValuesEvent.unsubscribe();
    }
}

